<div class="flex flex-col gap-10">
  <nz-descriptions
    data-test-id="summary"
    class="w-full"
    nzBordered
    nzSize="small"
    [nzTitle]="
      'pages.uploadFile.steps.progress.summary'
        | translate
          : {
              type:
                `models.branch.type.options.${metaDataModel.type}` | translate,
            }
    "
    [nzColumn]="2"
  >
    <nz-descriptions-item [nzTitle]="'models.branch.source.label' | translate">
      @if (metaDataModel.source) {
        {{ metaDataModel.source }}
      } @else {
        !
      }
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="'models.branch.reason.label' | translate">
      @if (metaDataModel.reason) {
        {{ metaDataModel.reason }}
      } @else {
        !
      }
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="'models.branch.note.label' | translate">
      {{ metaDataModel.note ?? '-' }}
    </nz-descriptions-item>
    @if (metaDataModel.type !== 'hkbw') {
      <nz-descriptions-item
        [nzTitle]="'models.branch.fundingCode.label' | translate"
      >
        {{ metaDataModel.fundingCode ?? '!' }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'models.branch.mevId.label' | translate">
        {{ metaDataModel.mevId ?? '-' }}
      </nz-descriptions-item>
    }
    <nz-descriptions-item
      [nzTitle]="'pages.uploadFile.steps.progress.fileName' | translate"
    >
      {{ file.name }}
    </nz-descriptions-item>
    <nz-descriptions-item
      [nzTitle]="'pages.uploadFile.steps.progress.fileSize' | translate"
    >
      {{ file.size | nzBytes }}
    </nz-descriptions-item>
    <nz-descriptions-item
      [nzTitle]="'pages.uploadFile.steps.progress.fileLength' | translate"
    >
      {{ fileLineCount }}
    </nz-descriptions-item>
  </nz-descriptions>

  @if (totalProcessStatus === 'error') {
    <app-process-error
      data-test-id="processError"
      size="large"
      [processFailureReason]="processFailureReason"
    />

    <div class="flex w-full justify-between">
      <app-button data-test-id="cancelButton" type="outline" routerLink="../">
        {{ 'pages.uploadFile.steps.progress.cancel' | translate }}
      </app-button>
      <app-button
        data-test-id="backToUpload"
        type="outline"
        (trigger)="onBackToUpload()"
      >
        {{ 'pages.uploadFile.steps.progress.back' | translate }}
      </app-button>
    </div>
  } @else {
    <div class="flex flex-col gap-4">
      <h3 class="text-lg font-bold text-blue-700">
        {{ 'pages.uploadFile.steps.progress.note' | translate }}
      </h3>

      @let globalActiveIndex =
        (fileUploadProcess === 100 ? 1 : 0) + activeProcessStateIndex + 1;

      <p class="-mb-1 text-sm">
        @if (globalActiveIndex > PROCESS_STATUS.length + 1) {
          {{ 'pages.uploadFile.steps.progress.success' | translate }}
        } @else {
          {{
            'pages.uploadFile.steps.progress.steps'
              | translate
                : {
                    active: globalActiveIndex,
                    total: PROCESS_STATUS.length + 1,
                  }
          }}
          -
          @if (fileUploadProcess !== 100) {
            {{ `pages.uploadFile.steps.progress.fileUpload` | translate }}
          } @else {
            {{
              `components.processBar.processStatus.${PROCESS_STATUS[activeProcessStateIndex]}`
                | translate
            }}
          }
        }
      </p>
      <div
        class="flex gap-2 *:h-2 *:w-full *:transition-colors *:duration-1000"
      >
        <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
        <div
          [attr.style]="`--tw-gradient-from-position:${fileUploadProcess}%`"
          [ngClass]="{
            'bg-grey-200': fileUploadProcess === 0,
            'bg-linear-to-r from-blue-500 from-0% to-grey-200 to-0%':
              fileUploadProcess < 100,
            'bg-success': fileUploadProcess === 100,
          }"
        ></div>
        @for (status of PROCESS_STATUS; track status) {
          <div
            class="bg-grey-200"
            [ngClass]="{
              'animate-bgFade':
                $index === this.activeProcessStateIndex &&
                fileUploadProcess === 100,
              'animate-bgFadeToSuccess bg-success':
                $index + 1 <= this.activeProcessStateIndex,
            }"
          ></div>
        }
      </div>
    </div>
  }
</div>
